import { defineStore } from 'pinia'
import { getPricingConfig } from '@/api/frontend'

type PricingConfig = {
  sra3_size_mm: [number, number],
  material_prices: Record<string, number>,
  min_archs: number
}

export const usePricingStore = defineStore('pricing', {
  state: () => ({
    loaded: false as boolean,
    sra3_size_mm: [320, 450] as [number, number],
    material_prices: {} as Record<string, number>,
    min_archs: 1 as number
  }),
  actions: {
    async fetch() {
      if (this.loaded) return
      const cfg: PricingConfig = await getPricingConfig()
      this.sra3_size_mm = cfg.sra3_size_mm
      this.material_prices = cfg.material_prices
      this.min_archs = cfg.min_archs
      this.loaded = true
    }
  }
})
